import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const sowTypeList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/unit-sow/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};

export const sowTypeAdd = (params) => {
  return _baseClient.post('/unit-sow/save', { body: params }).then((response) => {
    return response;
  });
};

export const sowTypeDelete = (params) => {
  return _baseClient.get('/unit-sow/delete', params);
};

export const sowTypeDetail = (params) => {
  return _baseClient.get('/unit-sow/get', params);
};

export const sowTypeUpdateStatus = (params) => {
  return _baseClient.get('/unit-sow/update-status', params);
};

export const sowServiceType = (params) => {
  return _baseClient.post('/unit-sow/query-list', { body: params });
};
